import {getQuery} from "@/modules/common/utils";

const list = (params) => getQuery('estimates', params)

export default {
  list,
}
